import {
  fireEventRecommendedGoods,
  fireRecommendViewItemListGAEvent,
  fireProductViewGAEvent,
  fireCustomProductViewEvent,
  fireInStoreInventoryEvent,
} from '@global/gtm/base';
import ProductGTM from '@global/gtm/class/productClass';

/**
 * 商品資訊物件
 * @typedef {Object} productInfo
 * @property {string} customMarketID - 商品客製化賣場 ID
 * @property {string} name - 商品名稱
 * @property {number} price - 商品價格
 * @property {string} affiliation - 商品顏色
 * @property {string} eventName - 活動名稱.
 */

export function fireShopContentView(productInfo) {
  window.dataLayer = window.dataLayer || [];

  const productGTM = new ProductGTM(productInfo);
  const productItemInfo = productGTM.getProductInfo();
  const price = productGTM.getProductPrice();

  fireCustomProductViewEvent({
    itemCategory: productItemInfo.item_category,
    itemCategory2: productItemInfo.item_category2,
    itemCategory3: productItemInfo.item_category3,
    itemID: productItemInfo.item_id,
    itemName: productItemInfo.item_name,
  });

  fireProductViewGAEvent({
    items: [productItemInfo],
    value: price,
  });
}

/**
 * Fires a Google Analytics event when a recommendation is clicked.
 *
 * @param {Object} payload - The payload containing information about the recommendation.
 * @param {array} payload.recommendedData - 推薦商品資料
 * @param {string} payload.recommendedMove - 點擊推薦商品的方向
 * @param {string} payload.recommendedType - 推薦商品的位置
 * @param {string} payload.productId - 主商品的客製化賣場 ID
 * @param {string} payload.productName - 主商品的名稱
 * @param {string} payload.itemListName - 推薦商品 list 名稱
 */
export function fireRecommendClickGAEvent(payload) {
  window.dataLayer = window.dataLayer || [];

  const transferData = ProductGTM.mapRecommendData(payload);

  fireEventRecommendedGoods({
    recommendedType: payload.recommendedType,
    recommendedMove: payload.recommendedMove,
    recommendedPage: window.location.pathname,
    recommendedProduct: transferData,
    productId: payload.productId.replace('SZ_', '') || '',
    productName: payload.productName,
  });
}

/**
 * Fires a Google Analytics event when a recommendation is clicked.
 *
 * @param {Object} payload - The payload containing information about the recommendation.
 * @param {array} payload.recommendedData - 推薦商品資料
 * @param {string} payload.recommendedMove - 點擊推薦商品的方向
 * @param {string} payload.recommendedType - 推薦商品的位置
 * @param {string} payload.productId - 主商品的客製化賣場 ID
 * @param {string} payload.productName - 主商品的名稱
 * @param {string} payload.itemListName - 推薦商品 list 名稱
 */
export function fireRecommendByCategoryClickEvent(payload) {
  window.dataLayer = window.dataLayer || [];

  const transferData = ProductGTM.mapRecommendDataByCategory(payload);

  fireEventRecommendedGoods({
    recommendedType: payload.recommendedType,
    recommendedMove: payload.recommendedMove,
    recommendedPage: window.location.pathname,
    recommendedProduct: transferData,
    productId: payload.productId.split('SZ')[0],
    productName: payload.productName,
  });
}

export function fireRecommendViewGAEvent(payload) {
  window.dataLayer = window.dataLayer || [];

  const recommendArray = ProductGTM.mapRecommendViewData(payload);

  fireRecommendViewItemListGAEvent({
    itemListName: payload.itemListName,
    items: recommendArray,
  });
}

export function fireRecommendViewGAEventByCategory(payload) {
  window.dataLayer = window.dataLayer || [];

  const recommendArray = ProductGTM.mapRecommendViewDataByCategory(payload);

  fireRecommendViewItemListGAEvent({
    itemListName: payload.itemListName,
    items: recommendArray,
  });
}

export function fireRecommendViewGAEventByBarcode(payload) {
  window.dataLayer = window.dataLayer || [];

  const recommendArray = ProductGTM.mapRecommendViewDataByBarcode(payload);

  fireRecommendViewItemListGAEvent({
    itemListName: payload.itemListName,
    items: recommendArray,
  });
}

export function fireRecommendClickEventByBarcode(payload) {
  window.dataLayer = window.dataLayer || [];

  const transferData = ProductGTM.mapRecommendDataByBarcode(payload);

  fireEventRecommendedGoods({
    recommendedType: payload.recommendedType,
    recommendedMove: payload.recommendedMove,
    recommendedPage: window.location.pathname,
    recommendedProduct: transferData,
    productId: payload.productId.replace('SZ_', ''),
    productName: payload.productName,
  });
}

export function fireInStoreInventory(payload) {
  window.dataLayer = window.dataLayer || [];

  fireInStoreInventoryEvent(payload);
}
